import { betaWhitelistEndpoints } from "./codBetaTest.api"

export const { useCheckBetaWhitelistQuery, useLazyCheckBetaWhitelistQuery } =
  betaWhitelistEndpoints
